import React, { createContext, useEffect, useState } from "react";
import {API} from "../api/API";
import _ from "lodash";
import { MESSAGES_URL, } from "../config/config";
import AppSpinner from "uiwidgets/AppSpinner";
import EmptySidebarLayout from "uiwidgets/layouts/EmptySidebarLayout";
import { extractError } from "api/ErrorUtil";
import ErrorBlock from "../uiwidgets/ErrorBlock";


export const MessagesContext = createContext();
export const MessagesContextProvider = (props) => {

    const [appMessages, setAppMessages] = useState({});
    const [appMessagesLoading, setAppMessagesLoading] = useState(true);
    const [apiError, setApiError] = useState({});
    
    

    useEffect(() => {
        console.log("Running App messages use effect");
        API.get(`${MESSAGES_URL}`)
            .then(resp => {
                setAppMessages(_.get(resp, "data", {}));
                setAppMessagesLoading(false);
            })
            .catch(error => {
                setAppMessagesLoading(false);
                setApiError(extractError(error));
            });
    }, []);

    if (!_.isEmpty(apiError)) {
        return (
            <EmptySidebarLayout><ErrorBlock error={apiError} /></EmptySidebarLayout>
        );
      }

    if (appMessagesLoading) {
        
        return <div className="loading-page">
            <div className="center">
                <AppSpinner />
            </div>
        </div>;
    }

    return (
        <MessagesContext.Provider value={{ messages: appMessages }}>
            {props.children}
        </MessagesContext.Provider>
    );
};
